import { render, staticRenderFns } from "./v-arrow-bg.vue?vue&type=template&id=69849334&scoped=true"
import script from "./v-arrow-bg.vue?vue&type=script&lang=js"
export * from "./v-arrow-bg.vue?vue&type=script&lang=js"
import style0 from "./v-arrow-bg.vue?vue&type=style&index=0&id=69849334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69849334",
  null
  
)

export default component.exports